import React from 'react';
import PropTypes from 'prop-types';
import { Link as InternalLink } from 'react-router-dom';

import { Field } from '@ontruck/orc';
import { Button } from 'refactored/ui/form';

import routes from 'utils/routes';
import { getCurrentTenantBusinessConfig } from '../../../tenant/business/signUp';
import styled from 'styled-components';

const RegisterWithLinkButtonComponent = ({ t, className }) => {
  const style = {
    color: 'var(--primary-btn500)',
    margin: '0px',
    padding: '0px',
  };
  return (
    <InternalLink className={className} to={routes.signup} style={style}>
      {t(`sign_up`)}
    </InternalLink>
  );
};

const RegisterWithLinkButton = styled(RegisterWithLinkButtonComponent)`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`;

const RegisterWithLinkComponent = ({ t, className }) => {
  return (
    <div className={className}>
      <span> {t('sign_up_have_an_account')} &nbsp;</span>
      <RegisterWithLinkButton
        className={className}
        t={t}
      ></RegisterWithLinkButton>
    </div>
  );
};

const RegisterWithLink = styled(RegisterWithLinkComponent)`
  display: flex;
  padding-top: 16px;
  align-items: center;
  gap: 10px;

  span {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-align: right;
    width: 80%;
  }
`;

const LoginForm = ({
  className,
  username,
  password,
  setUsername,
  setPassword,
  handleSubmit,
  error,
  t,
}) => {
  const businessConfig = getCurrentTenantBusinessConfig();
  return (
    <div className={className}>
      <h2 className="title">{t('title')}</h2>
      <form className={`form ${error && 'form-error'}`} onSubmit={handleSubmit}>
        <Field
          id="username"
          type="email"
          name="username"
          onChange={setUsername}
          label={t('username_label')}
          fullWidth
          value={username}
          dataE2E="login_username"
        />
        <div className="tax-data inspectlet-sensitive">
          <Field
            id="password"
            name="password"
            onChange={setPassword}
            label={t('password_label')}
            type="password"
            fullWidth
            value={password}
            dataE2E="login_password"
          />
        </div>
        {error && (
          <p data-e2e="login_error_message" className="error-msg">
            {t(error)}
          </p>
        )}
        <Button
          id="submit"
          type="submit"
          size="L"
          text={t('button_label')}
          dataE2E="login_submit"
        />
      </form>
      <InternalLink
        style={{ color: 'var(--primary500)' }}
        to={routes.loginRecover}
      >
        {t('password_recovery')}
      </InternalLink>
      {businessConfig.login.isFromLoginToSignUpEnabled && (
        <RegisterWithLink t={t}></RegisterWithLink>
      )}
    </div>
  );
};

LoginForm.propTypes = {
  className: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setUsername: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  t: PropTypes.func,
  error: PropTypes.string.isRequired,
};

LoginForm.defaultProps = {
  t: (t) => t,
};

export default LoginForm;
